import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import BestOffers from './views/BestOffers.vue';
import Smartphones from './views/Smartphones.vue';
import Medical from './views/Medical.vue';
import Videos from './views/Videos.vue';


Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [{
			path: '/',
			name: 'home',
			component: Home
		}, {
			path: '/best-offers',
			name: 'best-offers',
			component: BestOffers
		}, {
			path: '/smartphones',
			name: 'smartphones',
			component: Smartphones
		}, {
			path: '/virus',
			name: 'virus',
			component: Medical
		}, {
			path: '/videos',
			name: 'videos',
			component: Videos
		}
	]
})
